import React from "react";
import { CalendarClock } from "lucide-react";

const FORMATS = [["carousel", "Carousel"], ["story", "Story"], ["reel", "Reel"]];

export const AutoPublishRow = ({ post, igConnected, onUpdate }) => {
  const on = !!post.auto_publish;
  const formats = post.auto_formats || ["carousel", "story"];
  const options = post.kind === "niggle" ? [["niggle", "Story set"]] : FORMATS;
  const scheduled = !!post.scheduled_for;
  const toggleFmt = (f) => {
    const next = formats.includes(f) ? formats.filter((x) => x !== f) : [...formats, f];
    if (next.length) onUpdate({ auto_formats: next });
  };

  return (
    <div data-testid={`post-auto-row-${post.id}`} className="rounded-xl border border-zinc-800 bg-black/30 px-3 py-2.5 flex flex-wrap items-center gap-x-3 gap-y-2">
      <button
        role="switch"
        aria-checked={on}
        disabled={!scheduled}
        onClick={() => onUpdate({ auto_publish: !on })}
        data-testid={`post-auto-toggle-${post.id}`}
        className={`relative h-5 w-9 rounded-full transition-colors disabled:opacity-40 ${on ? "bg-[#BEFF38]" : "bg-zinc-700"}`}
      >
        <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-black transition-transform ${on ? "translate-x-4" : "translate-x-0.5"}`} />
      </button>
      <span className="text-xs text-zinc-300 flex items-center gap-1.5" data-testid={`post-auto-label-${post.id}`}>
        <CalendarClock className="w-3.5 h-3.5 text-[#BEFF38]" />
        {!scheduled ? "Set a date to auto-post" : on ? `Auto-posts ${post.scheduled_for} · 07:00 UK` : "Auto-post off"}
        {on && !igConnected && <span className="text-amber-300">· connect Instagram first</span>}
      </span>
      {on && (
        <div className="flex gap-1.5 ml-auto">
          {options.map(([f, label]) => {
            const active = formats.includes(f);
            const st = post.ig?.[`${f}_status`];
            return (
              <button
                key={f}
                onClick={() => toggleFmt(f)}
                data-testid={`post-auto-format-${f}-${post.id}`}
                className={`px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border transition-colors ${
                  active ? "border-[#BEFF38] text-[#BEFF38]" : "border-zinc-800 text-zinc-500 hover:text-white"
                }`}
              >
                {label}{st === "published" ? " ✓" : st === "failed" ? " !" : ""}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
